<template>
  <table :class="['ui striped basic table printable', { loading: loading }]">
    <div class="text loader">Carregando</div>
    <thead>
      <tr>
        <th v-if="showActions" :colspan="columnsCount" class="action-row">
          <div class="ui grid">
            <div class="row">
              <div class="four wide column">
                <router-link class="new-record" :to="newRecordPath">
                  <i class="plus icon"></i>Novo cadastro
                </router-link>
              </div>
              <div class="right aligned twelve wide column">
                <div class="actions">
                  <a @click.prevent="refresh()">
                    <i class="refresh icon"></i>Atualizar
                  </a>
                  <a v-if="showPrint" @click.prevent="print()">
                    <i class="print icon"></i>Imprimir
                  </a>
                  <a v-if="showCsv" @click.prevent="toCSV()">
                    <i class="file excel icon"></i>CSV
                  </a>
                </div>
              </div>
            </div>
          </div>
        </th>
      </tr>
      <tr v-show="showHeader">
        <th
          v-for="(col, index) in enableColumns"
          :key="index"
          :class="col.align ? `${col.align} aligned` : null"
        >
          {{ col.description }}
        </th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="(item, index) in items" :key="index">
        <div
          class="neutral"
          v-for="(col, colIndex) in enableColumns"
          :key="colIndex"
        >
          <td v-if="col.kind == 'status'" class="one wide center aligned">
            <span
              :class="[
                'ui',
                { red: !item[col.field] },
                { green: item[col.field] },
                'empty circular label'
              ]"
              :title="item[col.field] ? 'Ativo' : 'Inativo'"
            ></span>
          </td>
          <td v-else-if="col.kind == 'edit'" class="two wide">
            <router-link :to="editPath(item[col.field])">
              <i class="edit icon"></i> Editar
            </router-link>
          </td>
          <td v-else-if="col.kind == 'select'">
            <a @click.prevent="select(item)">{{ item[col.field] }}</a>
          </td>
          <td
            v-else-if="col.kind == 'link'"
            :class="col.align ? `${col.align} aligned` : null"
          >
            <router-link :to="mountContent(col.to, item)">
              {{ col.title }}
            </router-link>
          </td>
          <td
            v-else-if="col.kind == 'label'"
            :class="col.align ? `${col.align} aligned` : null"
          >
            <span
              :class="['ui', 'small', col.map[item[col.field]].color, 'label']"
            >
              {{ col.map[item[col.field]].description }}
            </span>
          </td>
          <td v-else :class="col.align ? `${col.align} aligned` : null">
            {{ item[col.field] }}
          </td>
        </div>
      </tr>
    </tbody>
    <tfoot>
      <tr v-show="pageCount > 1">
        <th :colspan="columnsCount" class="right aligned">
          <Paginate
            :page-count="pageCount"
            :click-handler="changePage"
            :total="paginate.total_entries"
            :entries="entriesOnPage"
            :value="paginate.current_page"
          ></Paginate>
        </th>
      </tr>
    </tfoot>
  </table>
</template>
<script>
import Paginate from './widgets/paginate';
import exportCSV from '@/utils/exportCSV';
import printTable from '@/utils/printTable';

export default {
  components: { Paginate },
  props: {
    columns: {
      type: Array,
      default: () => []
    },

    resource: {
      type: String,
      default: '/'
    },

    basePath: {
      type: String,
      default: null
    },

    showPrint: {
      type: Boolean,
      default: true
    },

    showActions: {
      type: Boolean,
      default: true
    },

    showHeader: {
      type: Boolean,
      default: true
    },

    showCsv: {
      type: Boolean,
      default: true
    }
  },

  data() {
    return {
      loading: false,
      items: [],
      paginate: {
        current_page: 0,
        per_page: 0,
        total_entries: 0
      }
    };
  },

  computed: {
    enableColumns() {
      return this.columns.filter(c => !c.disabled);
    },

    columnsCount() {
      return this.enableColumns.length;
    },

    pageCount() {
      return Math.ceil(this.paginate.total_entries / this.paginate.per_page);
    },

    entriesOnPage() {
      const page_count = Math.ceil(
        this.paginate.total_entries / this.paginate.per_page
      );

      if (this.paginate.current_page === 1) {
        return page_count === 1
          ? this.paginate.total_entries
          : this.paginate.per_page;
      }

      return (
        this.paginate.total_entries %
        ((page_count - 1) * this.paginate.per_page)
      );
    },

    newRecordPath() {
      return `/${this.path}/new`;
    },

    path() {
      return _.isEmpty(this.basePath) ? this.resource : this.basePath;
    }
  },

  methods: {
    mountContent(content, item) {
      Object.keys(item).forEach(field => {
        const tag = `:${field}`;
        content = content.replace(tag, item[field]);
      });
      return content;
    },

    refresh() {
      this.$emit('refresh');
    },

    print() {
      const { headers, data } = this.getHeadersAndData();
      printTable(headers, data);
    },

    toCSV() {
      const { headers, data } = this.getHeadersAndData();
      exportCSV(headers, data, `${this.resource}`);
    },

    getHeadersAndData() {
      const headers = this.enableColumns
        .filter(header => header.description)
        .map(header => header.description);

      const fields = this.enableColumns
        .filter(header => header.description)
        .map(header => header.field);

      const formatedData = this.items.map(item => {
        let column = {};
        fields.forEach(field => {
          column = {
            ...column,
            [field]: item[field] || ''
          };
        });
        return column;
      });

      return { headers, data: formatedData };
    },

    select(item) {
      this.$emit('selected', item);
    },

    _addQueryParam(params) {
      const queryParams = Object.assign({}, this.$route.query, params);
      this.$router.replace({
        path: this.$route.path,
        query: queryParams
      });
    },

    changePage(pageNumber) {
      // scroll to top
      this._addQueryParam({ page: pageNumber });
      this.$scrollTop();

      this.$emit('page', pageNumber);
    },

    editPath(id) {
      return `/${this.path}/${id}`;
    },

    toggleLoading() {
      this.loading = !this.loading;
    },

    setItems(items) {
      this.items = _.clone(items);
    },

    setPaginate(paginate) {
      this.paginate = _.clone(paginate);
    }
  }
};
</script>
<style lang="css" scoped>
table .text.loader {
  display: none;
}

table .text.loader::after {
  display: inline-block;
  animation: dotty steps(1, end) 2s infinite;
  content: '';
}

table.loading {
  position: relative;
  overflow: hidden;
  min-height: 200px;
}

table.loading::before {
  content: ' ';
  opacity: 0.7;
  position: absolute;
  width: 100%;
  height: 100%;
  background: white;
}

table.loading .text.loader {
  position: absolute;
  z-index: 1;
  display: table;
  width: 100%;
  text-align: center;
  padding: 1rem;
  color: rgba(0, 0, 0, 0.87);
  font-size: 1.2rem;
}

.actions {
  text-align: right;
  float: right;
  font-weight: 400;
}

th.action-row {
  background: var(--bg-color) !important;
}

.actions > a {
  margin-left: 10px;
}

ul.ui.buttons {
  padding: 0px;
}
</style>
